import { useLocation } from 'react-router-dom';
export const useQueryParams = () => {
  const {
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const getQueryParam = param => {
    return searchParams.get(param);
  };
  return {
    getQueryParam,
    search
  };
};
//# sourceMappingURL=useQueryParams.js.map